import { Component, OnInit } from '@angular/core';
import { AlertService } from '@kodit/core/services';
import { SupportAccessRequestDto, SupportAccessRequestService } from './support-access-request.service';

@Component({
  selector: 'kodit-support-access-request-list',
  templateUrl: './support-access-request-list.component.html',
  styleUrls: ['./support-access-request-list.component.scss'],
})
export class SupportAccessRequestListComponent implements OnInit {
  requests: SupportAccessRequestDto[] = [];
  isLoading = false;

  constructor(
    private _service: SupportAccessRequestService,
    private _alertService: AlertService
  ) {}

  ngOnInit(): void {
    this._load();
  }

  private _load(): void {
    this.isLoading = true;
    this._service.getRequests().subscribe({
      next: (res: any) => {
        this.requests = res?.data ?? [];
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  handleApprove(request: SupportAccessRequestDto): void {
    this._service.approve(request.id).subscribe({
      next: (res: any) => {
        if (res?.succeeded) {
          this._alertService.addSuccessMsg(`Test korisnik kreiran: ${res.data}`);
          this._load();
        } else {
          this._alertService.addFailedMsg(res?.messages?.[0] ?? 'Greška pri odobravanju zahteva.');
        }
      },
    });
  }

  handleReject(request: SupportAccessRequestDto): void {
    this._service.reject(request.id).subscribe({
      next: (res: any) => {
        if (res?.succeeded) {
          this._alertService.addSuccessMsg('Zahtev je odbijen.');
          this._load();
        } else {
          this._alertService.addFailedMsg(res?.messages?.[0] ?? 'Greška pri odbijanju zahteva.');
        }
      },
    });
  }
}
